<template>
  <div>
    <PageAllow controller="OrderProfit" action="billCostAnalyze" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 入库日期 / 时间类型 -->
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出/下载 按钮 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("billProfit.Export.excel") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="bill_code"
                    v-model="options.bill_code"
                    @text="billCodeKeyword = $event"
                    :label="$t('billProfit.Fields.bill_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="org_code"
                    v-model="options.org_code"
                    @text="orgCodeKeyword = $event"
                    :label="$t('billProfit.Fields.order_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="obj_name"
                    v-model="options.obj_name"
                    @text="Keyword = $event"
                    :label="$t('billProfit.Fields.obj_name')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistrictsWithDescendants
                    v-model="DistrictsSelected"
                    :label="$t('shopDailyReports.shopDistricts', [$consts.shopName()])"
                  />
                </v-col>
                <!-- 作废状态 -->
                <v-col cols="12" sm="6" md="3">
                  <SearcherStatus
                    :label="$t('CancelFlgs.title')"
                    :items="$consts.cancelFlgs"
                    v-model="options.cancel_flgs"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="bill_profit_analyze"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 合计 -->
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td colspan="5">
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td>
                  <span>{{ $t("Global.money") }}{{ total_fee | formatMoney }}</span>
                </td>
                <td >
                  <span>{{ $t("Global.money") }}{{ total_received | formatMoney }}</span>
                </td>
                <td>
                  <span>{{ $t("Global.money") }}{{ total_cost | formatMoney }}</span>
                </td>
                <!-- 毛利率 -->
                <td>
                  <span>{{ total_profit_rate }}</span>
                </td>
                <td></td>
              </tr>
              <!-- 小屏幕 -->
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                 <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("billProfit.Fields.fee") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ total_fee | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("billProfit.Fields.received") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ total_received | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("billProfit.Fields.total_price") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ total_price | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("billProfit.Fields.cost") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ total_cost | formatMoney }}
                  </div>
                </td>

                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("billProfit.Fields.profitRate") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ total_profit_rate }}
                  </div>
                </td>
              </tr>
            </template>

            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <template v-slot:item.bill_code="{ item }">
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.bill_code }}
              </span>
              <br />
              <v-chip
                v-if="item.cancel_flg"
                x-small
                label
                outlined
                color="danger"
              >{{ $t("CRUD.cancelled") }}
              </v-chip>
            </template>
            <!-- 账单创建时间 -->
            <template v-slot:item.created="{ item }">
              {{ item.created | formatTime }}
            </template>
            <!-- 下单时间 -->
            <template v-slot:item.order_created="{ item }">
              {{ item.order_created | formatTime }}
            </template>
            <!-- 对象 -->
            <template v-slot:item.object="{ item }">
              {{ item.shop_name }}
              <br />
              <span
                      class="text-no-wrap caption secondary--text"
                      :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.shop_code }}
              </span>
            </template>
            <!-- 账单应收款 -->
            <template v-slot:item.fee="{ item }">
              {{ $t("Global.money") }}{{ item.fee | formatMoney }}
            </template>
            <!-- 账单实收款 -->
            <template v-slot:item.received="{ item }">
              {{ $t("Global.money") }}{{ item.received | formatMoney }}
            </template>
            <!-- 销售总计 -->
            <template v-slot:item.total_price="{ item }">
              {{ $t("Global.money") }}{{ item.total_price | formatMoney }}
            </template>
            <!-- 成本总计 -->
            <template v-slot:item.total_cost="{ item }">
              {{ $t("Global.money") }}{{ item.total_cost | formatMoney }}
            </template>
            <!-- 明细 -->
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    color="info"
                    class="px-2 me-2"
                    :href="
                      '/#/bill-profit/bill-profit-detail/' + item.bill_id
                    "
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("MaterialDistribution.Fields.detail") }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [
                    $t("MaterialDistribution.Fields.detail"),
                  ])
                }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import OrderProfitAnalyze from "@/api/order_profit_analyze";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";


const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",

  district_ids: [],
  cancel_flgs: [0],
  org_code: "",
  obj_name: "",
};

export default {
  data: () => ({
    bill_profit_analyze: [],
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    orgCodeKeyword: "",
    billCodeKeyword: "",
    Keyword: "",
    loading: false,
    DistrictsSelected: [],
    total_fee: 0,
    total_received: 0,
    total_price: 0,
    total_cost: 0,
    total_profit_rate: "0%",
  }),
  components: {
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherDistrictsWithDescendants,
    SearcherKeyword,
    SearcherStatus,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.profitAnalyze"),
        disabled: false,
        href: "/order-profit",
      },
      {
        text: i18n.t("Nav.billProfit"),
        disabled: true,
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("orderProfitAnalyze.Fields.created_date"),
      },
      {
        key: "actual",
        text: i18n.t("orderProfitAnalyze.Fields.actual_time"),
      },
    ],
    headers() {
      var headers = [
        {
          text: i18n.t("billProfit.Fields.bill_code"),
          align: "start",
          sortable: false,
          value: "bill_code",
        },
        {
          text: i18n.t("billProfit.Fields.order_code"),
          align: "start",
          sortable: false,
          value: "order_code",
        },
        {
          text: i18n.t("billProfit.Fields.order_created"),
          align: "start",
          sortable: false,
          value: "order_created",
        },
        {
          text: i18n.t("billProfit.Fields.obj_name"),
          align: "start",
          sortable: false,
          value: "object",
        },
        {
          text: i18n.t("billProfit.Fields.bill_type"),
          align: "start",
          sortable: false,
          value: "bill_type_str",
        },
        {
          text: i18n.t("billProfit.Fields.fee"),
          align: "start",
          sortable: false,
          value: "fee",
        },
        {
          text: i18n.t("billProfit.Fields.received"),
          align: "start",
          sortable: false,
          value: "received",
        },
        {
          text: i18n.t("billProfit.Fields.cost"),
          align: "start",
          sortable: false,
          value: "total_cost",
        },
        {
          text: i18n.t("billProfit.Fields.profitRate"),
          align: "start",
          sortable: false,
          value: "profitRate",
        },
        // 操作
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
      return headers
    },

  },

  mounted() {
    this.$commonUtils
      .loadOptions("bill_profit_analyze", [
        "DistrictsSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign(this.options, {
        bill_code: this.billCodeKeyword,
        org_code: this.orgCodeKeyword,
        obj_name: this.keyword,
      });
      this.getDistributionMAFromAPI();
    },
    resetSearch() {
      this.DistrictsSelected = [];

      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getDistributionMAFromAPI() {
      this.loading = true;
      let options = JSON.parse(JSON.stringify(this.options));
      OrderProfitAnalyze.billCostAnalyze(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.bill_profit_analyze = response.data.bills;
            this.paging = response.data.paging;
            this.total_fee = response.data.total_fee;
            this.total_received = response.data.total_received;
            this.total_price = response.data.total_price;
            this.total_cost = response.data.total_cost;
            this.total_profit_rate = (response.data.total_profit_rate) ? response.data.total_profit_rate : "0%";
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportExcel() {
      OrderProfitAnalyze.billCostAnalyzeExport(JSON.parse(JSON.stringify(this.options)));
    },
  },
  watch: {
    // districtID: {
    //   handler() {
    //     this.getDistributionMAFromAPI();
    //   },
    // },
    options: {
      deep: true,
      handler() {
        this.getDistributionMAFromAPI();
        sessionStorage.setItem(
          "bill_profit_analyze-options",
          JSON.stringify(this.options)
        );
      },
    },
    //门店分组
    DistrictsSelected: {
      handler() {
        this.options.district_ids = this.DistrictsSelected
          ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "bill_profit_analyze-DistrictsSelected",
          JSON.stringify(this.DistrictsSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>